import { SurveyQuestionKind } from '@zeus/index'

/** Une question telle que l'écran l'édite ; `key` tient la ligne stable quand on la déplace. */
export type QuestionDraft = { key: string, kind: SurveyQuestionKind, label: string, isOverall: boolean }

/** Bornes de l'API (`survey-questions.ts`). */
export const SURVEY_LIMITS = { questions: 15, label: 300 } as const

let counter = 0
const nextKey = () => `q-${++counter}`

export function draftsFrom(questions: readonly { id: string, kind: SurveyQuestionKind, label: string, isOverall: boolean }[]): QuestionDraft[] {
  return questions.map(q => ({ key: q.id, kind: q.kind, label: q.label, isOverall: q.isOverall }))
}

export function addQuestion(drafts: readonly QuestionDraft[]): QuestionDraft[] {
  return [...drafts, { key: nextKey(), kind: SurveyQuestionKind.SCALE, label: '', isOverall: false }]
}

export function moveQuestion(drafts: readonly QuestionDraft[], index: number, by: -1 | 1): QuestionDraft[] {
  const target = index + by
  if (target < 0 || target >= drafts.length) return [...drafts]
  const next = [...drafts]
  ;[next[index], next[target]] = [next[target]!, next[index]!]
  return next
}

/** Une seule satisfaction globale : la choisir la retire aux autres, et une question libre ne peut pas l'être. */
export function setOverall(drafts: readonly QuestionDraft[], key: string): QuestionDraft[] {
  return drafts.map(d => ({ ...d, isOverall: d.key === key && d.kind === SurveyQuestionKind.SCALE }))
}

/** Ce qui empêche d'enregistrer, en clé i18n ; null quand tout va bien. */
export function questionsError(drafts: readonly QuestionDraft[]): string | null {
  if (drafts.length === 0) return 'surveyEditor.error.empty'
  if (drafts.some(d => !d.label.trim())) return 'surveyEditor.error.label'
  const overall = drafts.filter(d => d.isOverall)
  if (overall.length !== 1 || overall[0]!.kind !== SurveyQuestionKind.SCALE) return 'surveyEditor.error.overall'
  return null
}
